import type {Config} from '@/api/pageService';
import type {
  BlockDeviceMapping,
  Image,
  BlocksItem,
} from '@/api/pageService/client';
import type {Breakpoint} from '@travel-frontend/themes';

import {createDirectusAssetUrl} from '@/utils/createDirectusAssetUrl';

export const mapBreakpointToDeviceId = (
  breakpoint: Breakpoint
): keyof BlockDeviceMapping => {
  switch (breakpoint) {
    case 'xl':
    case 'lg': {
      return 'lg';
    }
    case 'md': {
      return 'md';
    }
    default: {
      return 'sm';
    }
  }
};

export const resolveImageUrl = (image: Image): string => {
  if (image.url) {
    return image.url;
  }
  if (image.type === 'directus' && image.id && image.extension) {
    return createDirectusAssetUrl(`${image.id}.${image.extension}`);
  }
  return '';
};

export const findContentBlock = ({
  deviceId,
  collectionId,
  config,
}: {
  deviceId: keyof BlockDeviceMapping;
  collectionId: string;
  config: Config | null;
}): BlocksItem | undefined => {
  if (!config) {
    return;
  }
  const contendId = config.content[deviceId]?.[0]?.id;
  if (!contendId) {
    return;
  }
  const contentBlock = config.blocks.find(
    (block) => block.id === contendId && block.collection === collectionId
  );
  return contentBlock;
};

export const findContentBlockItem = <T>({
  deviceId,
  collectionId,
  config,
}: {
  deviceId: keyof BlockDeviceMapping;
  collectionId: string;
  config: Config | null;
}) => {
  return findContentBlock({deviceId, collectionId, config})?.item as
    | T
    | undefined;
};
